/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.jsTestimonials = {
    init: function ($section) {
      this.$section = $section
      this.$sliderEl = $section.find('.slider-wrapper');
      this.$slides = this.$sliderEl.find('[data-index]')

      this.$slider = this.$sliderEl.flickity({
        // wrapAround: true,
        initialIndex: 1,
        prevNextButtons: false,
        pageDots: false,
        watchCSS: true,
        contain: true,
        cellAlign: 'center'
      });

      this.$section.on('click', '.testimonial__nav--prev', function () {
        this.$slider.flickity('previous');
      }.bind(this));

      this.$section.on('click', '.testimonial__nav--next', function () {
        this.$slider.flickity('next');
      }.bind(this));
      $(document).on('Resize:Custom', this.adjustPeak.bind(this));
      this.adjustPeak()
    },
    adjustPeak: function () {
      this.$slides.each((index, slide) => {
        $(slide)[0].style.removeProperty('width')
      })
      if (!isScreenSizeLarge()) {
        let width = this.$slides.eq(0).outerWidth()
        this.$slides.css('width', width - (width * 11) / 100 + 'px')
      }
      this.$slider.flickity('resize')
    },
    blockSelect: function ($section, blockId) {
      const $testimonialSlider = $section.find('.slider-wrapper');

      const slideIndex = $('#shopify-section-' + blockId).data('index');

      $testimonialSlider.flickity('select', slideIndex);
    },
    unload: function ($section) {
      const $slider = $section.find('.flickity-enabled');
      $slider.flickity('destroy');
      $('.testimonial__nav--prev').off();
      $('.testimonial__nav--next').off();
    }
  }

  /******/
})()
  ;